export const handleImportPsd = (_message, { commit, dispatch } = {}) => {
  if (commit) {
    commit('SET_PENDING_PSD_IMPORT', true);

    dispatch('addAndSaveMessage', {
      role: 'assistant',
      content: 'Please attach a PSD file (click the paperclip icon or drag it into the input), then send — I\'ll create a new layout and import it.',
    });
  }
};
